import { render, staticRenderFns } from "./myBorrowList.vue?vue&type=template&id=35d76088&"
import script from "./myBorrowList.vue?vue&type=script&lang=js&"
export * from "./myBorrowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports